import { Space, Typography, Form, InputNumber, Select, Checkbox, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuildingUser, faCircleQuestion } from '@fortawesome/pro-solid-svg-icons'
import { CompanyStepProps } from '../../types'
import { REVENUE_OPTIONS } from '../../constants'
import { checkField } from '../../inputSanityModel'
import InputWarning from '../InputWarning'
import BandSliderInput from '../BandSliderInput'
import { SLIDER_TRACKS } from '../../bandSliderModel'
import './StepFieldRow.css'

const { Title, Paragraph } = Typography

export const CompanyStep = ({ data, onChange }: CompanyStepProps) => {
  const salesGoalWarning = checkField('salesGoal', data.salesGoal)
  const profitMarginWarning = checkField('profitMargin', data.profitMargin)

  return (
    <Space
      direction="vertical"
      size="large"
      style={{
        width: '100%',
        maxWidth: '800px',
        padding: '40px 20px'
      }}
    >
      <div style={{
        backgroundColor: 'white',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Space direction="horizontal" size="middle" style={{ marginBottom: '16px' }}>
          <FontAwesomeIcon icon={faBuildingUser} style={{ fontSize: '24px', color: '#ff6b4a' }} />
          <Title level={3} style={{ margin: 0 }}>Your Company</Title>
        </Space>

        <Paragraph style={{ color: '#666', marginBottom: '32px' }}>
          Set your sales goals, desired profit margin, and revenue breakdown.
        </Paragraph>

        <Form layout="vertical">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Space className="step-field-row" direction="horizontal" size="large" style={{ width: '100%', alignItems: 'flex-start' }}>
              <Form.Item
                label={
                  <Space size="small">
                    <span>What is your estimated revenue this year?</span>
                    <Tooltip title="The whole 12 months — not one month, not one job. Not sure? Start with what you earned last year as a baseline.">
                      <FontAwesomeIcon icon={faCircleQuestion} style={{ color: '#999', cursor: 'help' }} />
                    </Tooltip>
                  </Space>
                }
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <InputNumber
                  prefix="$"
                  value={data.salesGoal}
                  onChange={(value) => onChange('salesGoal', value)}
                  formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ''))}
                  style={{ width: '100%' }}
                  size="large"
                />
                <InputWarning warning={salesGoalWarning} />
              </Form.Item>

              <Form.Item
                label={
                  <Space size="small">
                    <span>What is your desired profit margin?</span>
                    <Tooltip title="We've set this to the industry standard of 20%. You can adjust it, but we recommend keeping it above 15%.">
                      <FontAwesomeIcon icon={faCircleQuestion} style={{ color: '#999', cursor: 'help' }} />
                    </Tooltip>
                  </Space>
                }
                required
                style={{ flex: 1, marginBottom: 0 }}
              >
                <BandSliderInput
                  value={data.profitMargin}
                  onChange={(value) => onChange('profitMargin', value)}
                  track={SLIDER_TRACKS.profitMargin}
                  unit="percent"
                  placeholder="20"
                  warning={profitMarginWarning}
                  warnOnTrack
                />
              </Form.Item>
            </Space>

            <Form.Item
              label="Where does your revenue come from?"
              required
              style={{ marginBottom: 0 }}
            >
              <Select
                value={data.revenueSource}
                onChange={(value) => onChange('revenueSource', value)}
                options={REVENUE_OPTIONS}
                size="large"
              />
            </Form.Item>

            <Checkbox
              checked={data.seasonalSnowWork}
              onChange={(e) => onChange('seasonalSnowWork', e.target.checked)}
            >
              We also do seasonal snow work
            </Checkbox>
          </Space>
        </Form>
      </div>
    </Space>
  )
}
